"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Deny = require("./Deny.styled");
var Deny = function Deny(_ref) {
  var onDeny = _ref.onDeny,
    elementId = _ref.elementId;
  return _react["default"].createElement(_Deny.DenyContainer, {
    color: "light",
    variant: "outlined",
    onClick: onDeny,
    "data-testid": "deny-button",
    id: elementId
  }, "Deny");
};
Deny.propTypes = {
  onDeny: _propTypes["default"].func.isRequired,
  elementId: _propTypes["default"].string
};
var _default = exports["default"] = Deny;